import {registerExpressPaymentMethod} from '@woocommerce/blocks-registry';
import {getSetting} from '@woocommerce/settings';
import ExpressPaymentComponent from "./express-payment-component";
import {PaymentMethod} from "../../components";
import {getSettings, isCheckoutPage} from "../utils";

const getData = getSettings('braintree_fastlane');

const data = getSetting('braintree_fastlane_data');

registerExpressPaymentMethod({
    name: 'braintree_fastlane',
    canMakePayment: async () => {
        return isCheckoutPage();
    },
    content: <PaymentMethod content={ExpressPaymentComponent} getData={getData}/>,
    edit: <PaymentMethod content={ExpressPaymentComponent} getData={getData}/>,
    supports: {
        features: data.features
    }
})